import { render, staticRenderFns } from "./DNSResolverModal.vue?vue&type=template&id=6a12d689&scoped=true&"
import script from "./DNSResolverModal.vue?vue&type=script&lang=ts&"
export * from "./DNSResolverModal.vue?vue&type=script&lang=ts&"
import style0 from "./DNSResolverModal.vue?vue&type=style&index=0&id=6a12d689&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12d689",
  null
  
)

export default component.exports